import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router'
import { AccountService } from './account.service';

@Injectable()
export class AuthGuardSuperAdminService implements CanActivate{

  constructor(public accountService : AccountService, 
              public router : Router) { }

  /**
   * Return true if logged user has role SuperAdmin, otherwise
   * it redirects to dashboard
   */
  canActivate() : boolean {
    if (!this.accountService.isSuperAdmin()) {
      this.router.navigate(['dashboard']);
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard-super-admin.service.ts